export default "__VITE_ASSET__tKHsRaxs__"